import CheckPhone from './CheckPhone';

export default CheckPhone;
